import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Card, CardContent, Typography, Grid, Divider, Box, Alert, TextField } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Button, FormControl, InputLabel, MenuItem, Select, } from '@mui/material';
import moment from "moment";
import Swal from 'sweetalert2';
import ContractService from '../../services/contractService';
import { json } from 'react-router-dom';

const Cancelar = ({ setHide }) => {
    const dispatch = useDispatch()
    const _TAB = useSelector((store) => store.tab)
    const general = useSelector((store) => store.general)

    const [servicios, setServicios] = useState([])
    const [total, setTotal] = useState('$ ')
    const [atencion, setAtencion] = useState({ Atendidopor: '', FechaAtencion: '', NombrePagador: '', RutPagador: '', TelefonoPagador: '', EmailPagador: '', RegionPagador: '', DireccionPagador: '' })
    const [finiquitado, setFiniquitado] = useState(false);

    const [estado, setEstado] = useState('');
    const [comentarios, setComentarios] = useState('');
    const [fecha, setFecha] = useState('');
    const [hora, setHora] = useState('');
    const [motivo, setMotivo] = useState('');


    useEffect(() => {
        console.log("TAB", _TAB)
        if (_TAB?.contractFull?.pagador) {
            setAtencion({
                Atendidopor: '',
                FechaAtencion: _TAB?.interview?.fecha ? moment(_TAB.interview.fecha).format("DD-MM-YYYY HH:mm:ss") : '',
                NombrePagador: _TAB.contractFull.pagador.firstName + " " + _TAB.contractFull.pagador.lastName,
                RutPagador: _TAB.contractFull.pagador.identifier,
                TelefonoPagador: _TAB.contractFull.pagador.telephone,
                EmailPagador: _TAB.contractFull.pagador.email,
                //RegionPagador: _TAB.contractFull.pagador.,
                DireccionPagador: _TAB.contractFull.pagador.address
            })
        }

        var list = _TAB?.contractFull?.negocios?.flatMap((negocio) =>
            negocio.servicios.map((servicio) => ({
                lineaNegocio: negocio.name,
                servicio: servicio.name,
                costo: servicio.costo,
            }))
        )
        setServicios(list)
        try{
        setTotal(list.reduce((acc, s) => acc + s.costo, 0))
        }catch(e){console.log(e)}
        if (_TAB.contractFull?.finiquitado) {
            setFiniquitado(_TAB.contractFull.finiquitado ?? false)
        }
    }, [_TAB])

    const handleReset = () => {
        setHide()
        setEstado('');
        setComentarios('');
        setFecha('');
        setHora('');
        setMotivo('');
    };

    const handleSubmit = async () => {
        const datos = {
            estado,
            motivo,
            comentarios,
            fecha: (fecha == "" || fecha == null) ? null : fecha,
            hora: hora ? hora + ":00" : null,
            customerInterviewId: _TAB?.interview.id
        };

        if (!datos.estado || datos.estado == '') {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Seleccione la razon.",
                timer: 4000,
            })
            return
        }
        if (!datos.motivo || datos.motivo == '') {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Seleccione el motivo.",
                timer: 4000,
            })
            return
        }
        var response = await ContractService.cancelContract(datos);

        Swal.fire({
            position: "center",
            icon: response.status ? "success" : "error",
            title: response.message,
            timer: 4000,
            allowOutsideClick: !response.status,
            allowEscapeKey: !response.status,
            allowEnterKey: !response.status,
        })

        if (response.status) {

            setTimeout(() => {
                window.location.reload()
            }, 1500)
        }
        //dispatch({ type: 'UPDATE_CONTRACT', payload: response.data });



    };

    const motivosPendiente = [
        'Lo quiere pensar',
        'No asiste',
        'No contesta',
        'Otro'
    ];

    const motivosPerdido = [
        'Cliente no quiere servicio',
        'No puede pagarlo',
        'No aplica servicio',
        'Servicio no prestado por GD',
        'No asiste',
        'No contesta',
        'Otro'
    ];

    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '40px', p: 4 }} >

            <Card sx={{ /*maxWidth: 700, margin: 'auto', mt: 4,*/ boxShadow: 3 }}>
                <CardContent >
                    <Box display="flex" justifyContent="space-between" alignItems="center" /*sx={{ backgroundColor: '#a693ea'}}*/>
                        <Typography variant="h5" gutterBottom>
                            Cancelar contrato
                        </Typography>
                        <Button variant='outlined' onClick={handleReset}>Volver</Button>
                    </Box>

                    <Alert className='mt-2 mb-4' severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>

                    <Divider sx={{ mb: 2 }} />

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Atendido por:</strong> {atencion.Atendidopor}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Fecha Atención:</strong> {atencion.FechaAtencion}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Nombre:</strong> {atencion.NombrePagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>RUT:</strong> {atencion.RutPagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Email:</strong> {atencion.EmailPagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Teléfono:</strong> {atencion.TelefonoPagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} hidden>
                            <Typography><strong>Región:</strong> {atencion.RegionPagador ?? ''}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Dirección:</strong> {atencion.DireccionPagador}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography><strong>Monto Acordado Contrato: </strong> {total.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <TableContainer component={Paper} sx={{ boxShadow: 3, mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#C8BFE7' }}>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>LINEA DE NEGOCIO</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>SERVICIO</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>COSTO SERVICIO</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {servicios?.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.lineaNegocio}</TableCell>
                                <TableCell>{row.servicio}</TableCell>
                                <TableCell>{row.costo?.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell colSpan={2}></TableCell>
                            <TableCell>
                                <Typography sx={{ fontWeight: 'bold' }}>: Total Servicios</Typography>
                                <Typography>{total?.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</Typography>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>


            <Card sx={{ /*maxWidth: 700, margin: 'auto',*/ mt: 4, boxShadow: 3 }}>
                <CardContent >

                    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant="h6">Formulario de Cancelacion</Typography>

                        <FormControl fullWidth>
                            <InputLabel>Razon</InputLabel>
                            <Select
                                value={estado}
                                label="Estado"
                                onChange={(e) => setEstado(e.target.value)}
                                required
                            >
                                <MenuItem>Seleccione...</MenuItem>
                                <MenuItem value="pendiente">Pendiente</MenuItem>
                                <MenuItem value="perdido">Perdido</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <InputLabel>Motivo</InputLabel>
                            <Select
                                value={motivo}
                                label="Motivo"
                                onChange={(e) => setMotivo(e.target.value)}
                                required
                            >
                                <MenuItem>Seleccione...</MenuItem>
                                {estado === 'perdido' ?
                                    motivosPerdido.map((m, i) => (
                                        <MenuItem key={i} value={m}>{m}</MenuItem>
                                    ))
                                    :
                                    motivosPendiente.map((m, i) => (
                                        <MenuItem key={i} value={m}>{m}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>


                        {estado === 'pendiente' && (
                            <>
                                <TextField
                                    label="Fecha"
                                    type="date"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={fecha}
                                    onChange={(e) => setFecha(e.target.value)}
                                />

                                <TextField
                                    label="Hora"
                                    type="time"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={hora}
                                    onChange={(e) => setHora(e.target.value)}
                                />
                            </>
                        )}


                        <TextField
                            label="Comentarios"
                            multiline
                            rows={3}
                            fullWidth
                            value={comentarios}
                            onChange={(e) => setComentarios(e.target.value)}
                            required
                        />

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button variant="contained" color="primary" onClick={handleSubmit}>
                                Confirmar
                            </Button>
                        </Box>
                    </Box>


                </CardContent>
            </Card>

        </Box>
    )
}

export default Cancelar

/*
REEMPLAZAR TAGS
SELECCIONAR CAUSAS Y  DESACTIVAR EN LEGAL
QUITAR CUOTAS EN MANAGER
ENVIAR CORREO??
*/
